import React from "react";

import { ConfirmationModalWrapper } from "@components/common/ConfirmationModalWrapper";

import { InformationModesConsommationModalWrapper } from "@pages/Kiosk/InformationModesConsommationModalWrapper";
import { InformationModesModalWrapper } from "@pages/Kiosk/InformationModesModalWrapper";

import { BasketChangeConfirmationDialog } from "../../CartAlert/BasketChangeConfirmationDialog";
import useOrderSummary from "../OrderSummaryHook";
import WorkflowAlert from "../OrderSummeryAlert/OrderSummeryAlert";
import "./../index.css";

export default function OrderSummaryModals({
    open,
    setIsSummaryOrderOpened,

    isOrderAlert,
    isCartChanged,
    setIsOrderAlert,
}: orderSummaryModalsType): JSX.Element {
    const {
        handleCartChangedCLickEvent,
        isInformationModesModalOpened,
        isPrm,
        isInformationModesConsommationModalOpened,
        isConfirmationModalOpened,
    } = useOrderSummary(open, setIsSummaryOrderOpened, setIsOrderAlert);
    return (
        <React.Fragment>
            {isOrderAlert && (
                <WorkflowAlert
                    isOrderAlert={isOrderAlert}
                    setIsOrderAlert={setIsOrderAlert}
                    handleCartChangedCLickEvent={handleCartChangedCLickEvent}
                />
            )}
            {isCartChanged && (
                <BasketChangeConfirmationDialog
                    open={isCartChanged}
                    onClose={handleCartChangedCLickEvent}
                    isPrm={isPrm}
                />
            )}
            {isInformationModesModalOpened === true ? (
                <InformationModesModalWrapper />
            ) : null}
            {isInformationModesConsommationModalOpened === true ? (
                <InformationModesConsommationModalWrapper />
            ) : null}
            {isConfirmationModalOpened === true ? (
                <ConfirmationModalWrapper />
            ) : null}
        </React.Fragment>
    );
}
